import Vue from 'vue';
import Vuex from 'vuex';
import tooltips from './modules/tooltips';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    tooltips
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js